import React from "react";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { getCookies, removeCookie } from "../cookies";
import ReactDOM from 'react-dom';
import ReactHtmlParser from 'react-html-parser';
import PageNotFound from "../../components/common/PageNotFound";
import SomethingWentWrong from "../../components/common/SomethingWentWrong";
import secureRandom from "secure-random";

export const getRoutePath = "/ctidentity";

export const randomCount = () => {
  let bytes = secureRandom(1);
  if(bytes[0] <= 50){
    return 0;
  }
  else if (bytes[0] > 50 && bytes[0] <= 100){
    return 1;
  }
  else if (bytes[0] > 100 && bytes[0] <= 150){
    return 2;
  }
  else if (bytes[0] > 150 && bytes[0] <= 200){
    return 3;
  }
  else if (bytes[0] > 200 && bytes[0] <= 250){
    return 4;
  }
  else if (bytes[0] > 250 && bytes[0] <= 300){
    return 5;
  }
  else if (bytes[0] > 300 && bytes[0] <= 350){
    return 6;
  }
  else {
    return 6;
  }
};

export const getLoginUrl = () => {
  let ctAppSource;
  const locationUrl = window.location.origin;
  if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedev';
  } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutestg';
  } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedevc';
  } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutepsup';    
  } else if (locationUrl.indexOf('login.ct.gov') > 0) {
    ctAppSource = 'ctapproute';
  }
  const loginUrl = getCookies(`${ctAppSource}`);
  let url = "/ctidentity/login";
  if (loginUrl) {
    url += loginUrl;
  }
  return url;
};

export const getResetPasswordUrl = () => {
  let ctAppSource;
  const locationUrl = window.location.origin;
  if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedev';
  } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutestg';
  } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedevc';
  } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutepsup';    
  } else if (locationUrl.indexOf('login.ct.gov') > 0) {
    ctAppSource = 'ctapproute';
  }
  const resetUrl = getCookies(`${ctAppSource}`);
  let url = "/ctidentity/passwordreset";
  if (resetUrl) {
    url += resetUrl;
  }
  return url;
};

export const hasSpecialCharacter = (value) => {
  const specialCharacterRegEx = new RegExp(
    "[!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~]"
  );
  return specialCharacterRegEx.test(value);
};

export const getNestedObject = (nestedObj, pathArr) =>
  pathArr.reduce((obj, key) => (obj && obj[key] ? obj[key] : null), nestedObj);

export const formatDateString = (dateString) => {
  const dateValues = dateString.split("/");
  const date = dateValues[1];
  const month = dateValues[0];
  const year = dateValues[2];
  return `${year}${month}${date}`;
};

export const isValidDateFormat = (dateString) => {
  const dateValues = dateString.split("/");
  let isValid = true;
  if (dateValues.length !== 3) {
    isValid = false;
  } else {
    const date = parseInt(dateValues[1], 10);
    const month = parseInt(dateValues[0], 10);
    const year = parseInt(dateValues[2], 10);
    if (month > 12) {
      isValid = false;
    } else if (year < 1900 || year > 2100) {
      isValid = false;
    } else {
      const daysMapper = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (date > daysMapper[month - 1]) {
        isValid = false;
      }
    }
  }
  return isValid;
};

export const pageNotFound = (value) => {
  if(value){
    const setData = ReactHtmlParser(JSON.stringify(value.data));
  ReactDOM.render(     
   <PageNotFound setData = {setData} />,
   document.getElementById('root')        
  );
  }
};

export const somethingWentWrong = () => {
  ReactDOM.render(     
   <SomethingWentWrong  />,
   document.getElementById('root')        
  );
};

export const setSessionValue = (name, value) => {
  sessionStorage.setItem(name, value);
};

export const getSessionValue = (name) => sessionStorage.getItem(name);

export const removeSessionValue = (name) => {
  sessionStorage.removeItem(name);
};

export const setLocalStorageValue = (name, value) => {
  localStorage.setItem(name, value);
};

export const getLocalStorageValue = (name) => localStorage.getItem(name);

export const removeLocalStorageValue = (name) => {
  localStorage.removeItem(name);
};
export const isPasswordFormatValid = (value) => {
  return (
    value.length < 9 ||
    value.length > 64 ||
    !hasSpecialCharacter(value) ||
    !value.match("[A-Z]") ||
    !value.match("[a-z]") ||
    !value.match("[0-9]")
  );
};

export const formatPhoneNumber = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;
  
  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) {
      return currentValue;
    }
    if (cvLength < 7) {
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    }
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
  return currentValue;
};

export const getPhoneNumberFromFormattedString = (formattedPhone) => `+1${formattedPhone.substring(1, 4)}${formattedPhone.substring(6, 9)}${formattedPhone.substring(10)}`;

export const getFormattedPhoneNumberFromUSFormat = (number) => {
  if (number) {
    if (number.length !== 12) {
      return null;
    }
    return `(${number.substring(2, 5)}) ${number.substring(5, 8)}-${number.substring(8)}`;
  }
  return number;
};

export const preventNonDigitCharacters = (e) => {
  let charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
  if (charCode !== 13) {
    if (charCode >= 96 && charCode <= 105) {
      charCode -= 48;
    }
    let keyboardAction = false;
    const allowedKeys = [65, 67, 86, 88];
    if (
      allowedKeys.indexOf(e.keyCode) > -1 &&
      (e.ctrlKey === true || e.metaKey === true)
    ) {
      keyboardAction = true;
    }
    const isShiftKey = e.shiftKey || false;
    const charStr = String.fromCharCode(charCode);
    let isAllowedSpecialChars = false;
    if (/\W/.test(charStr)) {
      isAllowedSpecialChars = charCode === 8 || charCode === 9;
    }
    if (
      (isShiftKey && !isAllowedSpecialChars) ||
      (/\D/.test(charStr) && !keyboardAction && !isAllowedSpecialChars)
    ) {
      e.preventDefault();
    }
  }
};

export const removeAllStorageValues = () => {
  let ctAppSource;
  const locationUrl = window.location.origin;
  if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedev';
  } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutestg';
  } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutedevc';
  } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
    ctAppSource = 'ctapproutepsup';    
  } else if (locationUrl.indexOf('login.ct.gov') > 0) {
    ctAppSource = 'ctapproute';
  }
  
  if (getCookies(`${ctAppSource}`)) {
    removeCookie(`${ctAppSource}`);
  }
  if (getSessionValue("idproofingParams")) {
    removeSessionValue("idproofingParams");
  }
  if(getCookies("AMDatastoreToken")){
    removeCookie("AMDatastoreToken");
  }
  if(getCookies("resubmitDataStoreToken")){
    removeCookie("resubmitDataStoreToken");
  }
};

const userLogout = () => {
  removeAllStorageValues();
  if (getLocalStorageValue("isUserLogin")) {
    removeLocalStorageValue("isUserLogin");
  }
  const locationUrl = window.location.origin;
  let logOutUrl;
  if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
    logOutUrl = '/openam/IDPSloInit?metaAlias=/BOSCitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
  } else {
    logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
  }
  const loginUrl = '/ctidentity/login';
  window.location.href = sanitizeUrl(`${locationUrl}${logOutUrl}${locationUrl}${loginUrl}`);
};

let time;
const resetTimer = () => {
  clearTimeout(time);
  time = setTimeout(
    userLogout,
    15 * 60 * 1000
  );
};

export const logoutTimer = () => {
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer;
  window.onclick = resetTimer; 
  window.onscroll = resetTimer;
  window.onkeypress = resetTimer;
};
